import React, { useState } from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import { useNavigate } from "react-router-dom";
import Sidebar from "../AdminPanel/Sidebar";
import TopBar from "../AdminPanel/TopBar";
import { useDashboardTheme } from "../../../context/DashboardThemeContext";
import ProductCategories from "./Categories/ProductCategories";
import ProductBrands from "./Categories/ProductBrands";

export default function Categories() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { dashboardTheme } = useDashboardTheme();
  const navigate = useNavigate();

  const outlinedButtonSx = {
    minHeight: 40,
    px: 2.4,
    borderRadius: "12px",
    textTransform: "none",
    fontWeight: 700,
    color: dashboardTheme.button_color,
    borderColor: dashboardTheme.button_color,
    boxShadow: "none",
    "&:hover": {
      borderColor: dashboardTheme.button_color,
      bgcolor: `${dashboardTheme.button_color}12`,
      boxShadow: "none",
    },
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: dashboardTheme.dashboard_background,
        display: "flex",
        color: dashboardTheme.text_color,
        overflowX: "hidden",
      }}
    >
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <TopBar
          sidebarOpen={sidebarOpen}
          onToggleSidebar={() => setSidebarOpen((prev) => !prev)}
        />

        <Box
          component="main"
          sx={{
            flex: 1,
            width: "100%",
            p: { xs: 1.5, sm: 2, md: 3 },
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", lg: "95%" },
              mx: "auto",
              mt: { xs: 1, md: 1.5 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: { xs: "stretch", sm: "center" },
                justifyContent: "space-between",
                flexDirection: { xs: "column", sm: "row" },
                gap: 1.5,
                mb: { xs: 1.5, md: 2 },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: 24, sm: 26, md: 30 },
                  fontWeight: 600,
                  color: dashboardTheme.primary_color,
                  lineHeight: 1.2,
                }}
              >
                Categorías y Marcas
              </Typography>

              <Button
                variant="outlined"
                startIcon={<ArrowBackRoundedIcon />}
                onClick={() => navigate(-1)}
                sx={outlinedButtonSx}
              >
                Regresar
              </Button>
            </Box>

            <Paper
              elevation={0}
              sx={{
                borderRadius: { xs: "10px", md: "12px" },
                border: `1px solid ${dashboardTheme.border_color}`,
                bgcolor: dashboardTheme.card_background,
                p: { xs: 1.5, sm: 2, md: 2.5 },
              }}
            >
              <Stack spacing={3}>
                <ProductCategories />
                <ProductBrands />
              </Stack>
            </Paper>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}